import { useNavigate } from 'react-router-dom'
import { useCartStore } from '../stores/cartStore'

// There was previously no persistent way back to /cart at all -- the only
// route in was the one-time redirect handleAddToCart does right after a
// successful add. Navigating away, refreshing, or wanting to check the cart
// before adding anything left no way back short of typing the URL. Mirrors
// MessageBell/NotificationBell's icon+badge pattern for consistency; the
// cart store is already kept in sync app-wide by CartSync (App.tsx), so this
// just reads it directly rather than polling.
export default function CartIcon() {
  const navigate = useNavigate()
  const itemCount = useCartStore((s) => s.items.length)

  return (
    <button
      type="button"
      onClick={() => navigate('/cart')}
      aria-label="Cart"
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <span className="mdi mdi-cart-outline" style={{ fontSize: '1.5rem', color: 'var(--text-secondary)' }} />
      {itemCount > 0 && (
        <span
          style={{
            position: 'absolute',
            top: '-4px',
            right: '-4px',
            background: '#E53E3E',
            color: 'white',
            fontSize: '0.625rem',
            fontWeight: 700,
            borderRadius: '9999px',
            minWidth: '16px',
            height: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 4px',
          }}
        >
          {itemCount > 9 ? '9+' : itemCount}
        </span>
      )}
    </button>
  )
}
